import { render, staticRenderFns } from "./dr-spacer.vue?vue&type=template&id=2a273ff8"
import script from "./dr-spacer.vue?vue&type=script&lang=js"
export * from "./dr-spacer.vue?vue&type=script&lang=js"
import style0 from "./dr-spacer.vue?vue&type=style&index=0&id=2a273ff8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../player/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports